/**
 * WaveformToolbarWrapper Component
 * Wrapper for Waveform Editing Toolbar
 */

import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { WaveformToolbar } from '../waveform';

export const WaveformToolbarWrapper = ({
  isVisible,
  hasSelection,
  hasClipboard,
  canUndo,
  canRedo,
  isPlaying,
  loopEnabled,
  onCut,
  onCopy,
  onPaste,
  onDelete,
  onUndo,
  onRedo,
  onZoomIn,
  onZoomOut,
  onToggleLoop,
  onPlay,
  onPause,
  onStop,
}) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <WaveformToolbar
          hasSelection={hasSelection}
          hasClipboard={hasClipboard}
          canUndo={canUndo}
          canRedo={canRedo}
          isPlaying={isPlaying}
          loopEnabled={loopEnabled}
          onCut={onCut}
          onCopy={onCopy}
          onPaste={onPaste}
          onDelete={onDelete}
          onUndo={onUndo}
          onRedo={onRedo}
          onZoomIn={onZoomIn}
          onZoomOut={onZoomOut}
          onToggleLoop={onToggleLoop}
          onPlay={onPlay}
          onPause={onPause}
          onStop={onStop}
        />
      )}
    </AnimatePresence>
  );
};

export default WaveformToolbarWrapper;
